/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import store from '../../../../../redux/store';
import { capitalizeFirstLetter, removeLastLetter } from 'serenova-js-utils/strings';
import { Button, AutoCompleteField, PlusIconSVG } from 'cx-ui-components';
import { SelectInputField } from "./SelectInputField";
import { customSortStringMethod } from "../../../../../utils";

const SortWrapper = styled.div`
  display: block;
  width: 80%;
  margin-left: 25px;
`
const FiltersAutoCompleteWrapper = styled.div`
  display: flex;
`;
const ActionButton = styled(Button)`
  margin-left: 10px;
  height: 32px;
  padding: 3px 10px;
  background-color: ${(props) => (props.disabled ? '#efefef' : 'inherit')};
`;
const StyledActionButton = styled(ActionButton)`
  margin-left: 0px !important;
`;
const SortOrderContainer = styled.div`
  display: inline-block;
  font-size: 14px;
  margin-left: 185px;
`;

export const SortByEntityField = ({ index, entity, listItems, suggestions, basicQuery }) => {
  const sortOrderOptions = [
    {
      label: 'Ascending',
      value: 'asc',
    },
    {
      label: 'Descending',
      value: 'des',
    }
  ];

  const addedItems = listItems ? listItems.map(
    (item) => item.name
  ).sort(
    (item1, item2) => customSortStringMethod(item1, item2)
  ) : [];

  const options = suggestions ? suggestions.filter(
    (suggestion) => !addedItems.includes(suggestion)
  ).sort(
    (option1, option2) => customSortStringMethod(option1, option2)
  ) : [];

  const entityName = entity && capitalizeFirstLetter(removeLastLetter(entity));
  const selectedEntityItem = basicQuery.getIn([index, 'sortBy', entity, 'sortBy', 'val']);
  const sortByOrderValue = basicQuery.getIn([index, 'sortBy', entity, 'order', 'val']);
  const isActionBtnDisabled = !selectedEntityItem || !sortByOrderValue;

  return (
    <Fragment>
      <SortWrapper>
        <FiltersAutoCompleteWrapper>
          <AutoCompleteField
            name={`basicQuery[${[index]}][sortBy]${entity}.sortBy[val]`}
            label={`Sort by ${entity}`}
            placeholder={`Select ${entityName}...`}
            suggestedDropDownWidth="100%"
            suggestions={options}
            labelWidth="175px"
            suggestedDropdownStyle={{ width: '300px', overflowX: 'hidden', whiteSpace: 'nowrap' }}
            disabled={false}
            required
          />
          <StyledActionButton
            type="button"
            onClick={() => {
              store.dispatch({ type: 'ADD_SORT_ITEM', index: index, entity: entity });
            }}
            disabled={isActionBtnDisabled}
            title={`Add ${entityName}`}>
            <PlusIconSVG size={12} plusIconType="secondary" />
          </StyledActionButton>
        </FiltersAutoCompleteWrapper>
        <SortOrderContainer>
          <SelectInputField
            name={`basicQuery[${[index]}][sortBy]${entity}.order[val]`}
            index={index}
            placeholder={'Select order...'}
            options={sortOrderOptions}
            disabled={false}
            data-automation="queueSortByList"
          />
        </SortOrderContainer>
      </SortWrapper>
    </Fragment>
  );
};

SortByEntityField.propTypes = {
  index: PropTypes.number,
  entity: PropTypes.string,
  listItems: PropTypes.array,
  suggestions: PropTypes.array,
  basicQuery: PropTypes.object,
};
